export enum AppScreen {
    Loading = 'loading',
    Welcome = 'welcome',
    Upload = 'upload',
    SelectTimePeriod = 'select-time-period',
    Map = 'map',
    WrapUp = 'wrap-up',
    BigYear = 'big-year',
    Checklist = 'checklist'
}
